import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.976 13.879a.356.356 0 0 1-.001-.051c0-.023 0-.046-.005-.07l-1.645-6.58a1 1 0 1 0-1.94.485L17.72 13H2.28l1.501-6h4.772a1 1 0 1 0 0-2H3a1 1 0 0 0-.97.757l-2 8c-.006.023-.005.046-.005.07 0 .016.001.033-.001.05-.002.02-.007.037-.012.055A.25.25 0 0 0 0 14v4.509A1.49 1.49 0 0 0 1.491 20h17.018A1.49 1.49 0 0 0 20 18.509V14c0-.024-.006-.046-.012-.068l-.001-.004c-.005-.016-.01-.032-.011-.049z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.239 5l.556-2.294.961.242a1.001 1.001 0 0 0 .488-1.94L12.365.03a1 1 0 0 0-.488 1.94l.978.247-1.725 7.127a3.042 3.042 0 0 1-.683-.24c-2.403-1.199-4.759-.065-4.891-.001l-.003.001a1.001 1.001 0 0 0 .894 1.79l.003-.001c.081-.037 1.628-.735 3.103.001a5.251 5.251 0 0 0 2.366.549c1.398 0 2.45-.51 2.527-.547l.001-.001a1.002 1.002 0 0 0-.894-1.79c-.11.049-.223.092-.338.128L13.755 7l.484-2z"
});

var SvgSandboxMajor = function SvgSandboxMajor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export { SvgSandboxMajor as S };
